import React from "react";
import Select from "react-select";
import { Typography } from "@mui/material";
import CustomInputLabel from "../customInputLabel";

const CustomMultiSelect = ({
  label,
  placeholder = "Select options",
  value = [],
  onChange,
  options = [],
  error = false,
  errorMessage = "",
  isSearchable = true,
  isClearable = true,
  isDisabled = false,
  required = false,
  sx = {},
  ...props
}) => {
  const handleChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    onChange(values);
  };

  const getValue = () => {
    if (!Array.isArray(value)) return [];
    return value.map((val) => {
      const option = options.find((opt) => opt.value === val);
      return option || { value: val, label: val };
    });
  };

  return (
    <div style={{ width: "100%", ...sx }}>
      {label && <CustomInputLabel label={label} />}

      <Select
        isMulti
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        placeholder={placeholder}
        value={getValue()}
        onChange={handleChange}
        options={options}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            minHeight: "34px",
            border: error ? "1px solid #ef4444" : "1px solid #E5E7EB",
            borderRadius: "8px",
            backgroundColor: isDisabled ? "#f9fafb" : "#fff",
            "&:hover": {
              borderColor: error ? "#ef4444" : "#D1D5DB",
            },
            ...(state.isFocused && {
              borderColor: error ? "#ef4444" : "#4CAF50",
              boxShadow: error ? "0 0 0 1px #ef4444" : "0 0 0 1px #4CAF50",
            }),
          }),
          multiValue: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: "#4CAF50",
            borderRadius: "6px",
          }),
          multiValueLabel: (baseStyles) => ({
            ...baseStyles,
            color: "white",
            fontSize: "12px",
            fontWeight: "500",
          }),
          multiValueRemove: (baseStyles) => ({
            ...baseStyles,
            color: "white",
            "&:hover": {
              backgroundColor: "#2E7D32",
              color: "white",
            },
          }),
          placeholder: (baseStyles) => ({
            ...baseStyles,
            color: "#9CA3AF",
            fontSize: "14px",
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            zIndex: 9999,
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: state.isSelected
              ? "#4CAF50"
              : state.isFocused
              ? "#E8F5E8"
              : "white",
            color: state.isSelected ? "white" : "#374151",
            "&:hover": {
              backgroundColor: state.isSelected ? "#4CAF50" : "#E8F5E8",
            },
          }),
          indicatorSeparator: () => ({
            display: "none",
          }),
          ...props.customStyles,
        }}
        {...props}
      />

      {error && errorMessage && (
        <Typography
          variant="caption"
          color="error"
          sx={{ mt: 0, ml: 1.5, display: "block" }}
        >
          {errorMessage}
        </Typography>
      )}
    </div>
  );
};

export default CustomMultiSelect;
